import config from "./config";
var axios = config();

export default {
  getIncompleteUpdates() {
    return axios.get("/api/InformationUpdates/GetIncompleteUpdates", {});
  },

  getCompletedUpdates() {
    return axios.get("/api/InformationUpdates/GetCompleteUpdates", {});
  },

  postComplete(informationUpdate) {
    return axios.post("/api/InformationUpdates/Complete", informationUpdate);
  },

  createInformationUpdateEmail(informationUpdateId) {
    return axios.post(
      "/api/InformationUpdates/CreateInformationUpdateEmail/" +
        informationUpdateId
    );
  }
};
